// Import de jQuery pour pouvoir l'utiliser dans ce fichier
import $ from "jquery";

// Import de Plyr pour le lecteur audio
import Plyr from 'plyr';

// URL du titre SoundCloud
const SOUNDCLOUD_URL = 'https://soundcloud.com/kalkimusic/webecomelight';

// Options de configuration
const USE_COMPACT_WIDGET = true; // Utiliser le widget compact de SoundCloud
const USE_PLYR = false; // Utiliser Plyr avec SoundCloud (si false, on utilise le widget standard de SoundCloud)

// Initialiser le lecteur SoundCloud avec l'iframe embed
const initSoundCloudEmbed = () => {
  try {
    if (USE_PLYR) {
      initPlyrWithSoundCloud();
      return;
    }

    // Créer un iframe pour intégrer SoundCloud
    const iframe = document.createElement('iframe');
    iframe.id = 'soundcloud-iframe';
    iframe.width = '100%';
    iframe.height = USE_COMPACT_WIDGET ? '166' : '450'; // Hauteur réduite pour le widget compact
    iframe.style.overflow = 'hidden'; // Remplace l'attribut scrolling déprécié
    iframe.style.border = 'none'; // Remplace l'attribut frameBorder déprécié
    iframe.allow = 'autoplay';

    // Configuration de l'URL du widget SoundCloud
    let widgetParams = 'color=%2300ffff&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false';

    if (USE_COMPACT_WIDGET) {
      // Widget compact
      widgetParams += '&visual=false';
    } else {
      // Widget standard
      widgetParams += '&visual=true';
    }

    iframe.src = `https://w.soundcloud.com/player/?url=${encodeURIComponent(SOUNDCLOUD_URL)}&${widgetParams}`;

    console.log('SoundCloud iframe URL:', iframe.src);

    // Trouver le conteneur pour l'audio
    const audioContainer = document.getElementById('player').parentNode;
    if (!audioContainer) {
      console.error('Audio container not found');
      return;
    }

    // Supprimer l'élément audio existant
    const playerElement = document.getElementById('player');
    if (playerElement) {
      playerElement.remove();
    }

    // Ajouter l'iframe SoundCloud
    audioContainer.appendChild(iframe);

    // Ajuster le style du conteneur pour le widget compact si nécessaire
    if (USE_COMPACT_WIDGET) {
      audioContainer.style.height = '80px';
      audioContainer.style.minHeight = '80px';
    }

  } catch (e) {
    console.error('Error initializing SoundCloud embed:', e);
  }
};

// Initialiser Plyr avec le widget SoundCloud
const initPlyrWithSoundCloud = () => {
  try {
    // Créer un élément audio pour Plyr
    const audio = document.createElement('audio');
    audio.id = 'player';
    audio.className = 'plyr-soundcloud';
    audio.controls = true;

    // Trouver le conteneur pour l'audio
    const audioContainer = document.getElementById('player').parentNode;
    if (!audioContainer) {
      console.error('Audio container not found');
      return;
    }

    // Supprimer l'élément existant
    const existingPlayer = document.getElementById('player');
    if (existingPlayer) {
      existingPlayer.remove();
    }

    // Ajouter l'élément audio pour Plyr
    audioContainer.appendChild(audio);

    // Créer un élément pour afficher les informations du morceau
    const trackInfoElement = document.createElement('div');
    trackInfoElement.className = 'track-info';
    trackInfoElement.innerText = 'We Become Light - Kalki';

    // Si l'élément .now-playing existe, on y ajoute les infos du morceau
    const nowPlayingContainer = document.querySelector('.now-playing');
    if (nowPlayingContainer) {
      nowPlayingContainer.innerHTML = '';
      nowPlayingContainer.appendChild(trackInfoElement);
    } else {
      // Sinon, on crée un conteneur
      const container = document.createElement('div');
      container.className = 'now-playing';
      container.appendChild(trackInfoElement);
      audioContainer.appendChild(container);
    }

    // Initialiser Plyr avec des contrôles personnalisés
    const player = new Plyr('#player', {
      controls: ['play', 'progress', 'current-time', 'mute', 'volume'],
      volume: 0.7
    });

    // Intégrer SoundCloud dans un iframe caché pour contrôler via l'API
    createHiddenSoundCloudPlayer();

    // Ajouter des événements pour la synchronisation entre Plyr et SoundCloud
    player.on('play', () => {
      if (window.scWidget) {
        window.scWidget.play();
      }
    });

    player.on('pause', () => {
      if (window.scWidget) {
        window.scWidget.pause();
      }
    });

    player.on('seeked', () => {
      if (window.scWidget) {
        const position = player.currentTime * 1000;
        window.scWidget.seekTo(position);
      }
    });

  } catch (e) {
    console.error('Error initializing Plyr with SoundCloud:', e);
    // En cas d'erreur, revenir au widget standard
    initSoundCloudEmbed();
  }
};

// Créer un lecteur SoundCloud caché pour obtenir l'audio
const createHiddenSoundCloudPlayer = () => {
  // Créer un iframe caché pour SoundCloud
  const iframe = document.createElement('iframe');
  iframe.id = 'soundcloud-widget';
  iframe.src = `https://w.soundcloud.com/player/?url=${encodeURIComponent(SOUNDCLOUD_URL)}&color=%2300ffff&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false`;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  // Charger l'API SoundCloud
  loadSoundCloudAPI().then(() => {
    if (window.SC) {
      window.scWidget = window.SC.Widget(iframe);

      // Écouter les événements SoundCloud
      window.scWidget.bind(window.SC.Widget.Events.READY, () => {
        console.log('SoundCloud widget ready');

        // Obtenir la durée pour initialiser correctement Plyr
        window.scWidget.getDuration((duration) => {
          const playerElement = document.getElementById('player');
          if (playerElement && playerElement.plyr) {
            playerElement.plyr.duration = duration / 1000;
          }
        });
      });

      window.scWidget.bind(window.SC.Widget.Events.PLAY_PROGRESS, (data) => {
        const playerElement = document.getElementById('player');
        if (playerElement && playerElement.plyr && !playerElement.plyr.seeking) {
          playerElement.plyr.currentTime = data.currentPosition / 1000;
        }
      });
    }
  });
};

// Charger l'API SoundCloud
const loadSoundCloudAPI = () => {
  return new Promise((resolve, reject) => {
    if (window.SC) {
      resolve(window.SC);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://w.soundcloud.com/player/api.js';
    script.onload = () => {
      console.log('SoundCloud API loaded');
      resolve(window.SC);
    };
    script.onerror = (error) => {
      console.error('Failed to load SoundCloud API:', error);
      reject(error);
    };
    document.body.appendChild(script);
  });
};

// Fonction principale pour charger le SDK SoundCloud
const loadSoundCloudSDK = () => {
  initSoundCloudEmbed();
};

// Exporter les fonctions nécessaires
export { loadSoundCloudSDK };
